import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { InlineTextButton, ModalWithoutIntl, PrimaryButton } from '../../components';

import css from './Confirm.module.css';

const ConfirmModal = ({
  id = 'ConfirmModal',
  title,
  messages = [],
  okText = 'OK',
  cancelText = 'Cancel',
  onConfirm,
  type,
  onClose,
  showCloseButton = true,
  titleClassName,
  confirmInProgress,
  confirmError,
  showSecondaryActionButton = false,
  secondaryActionText,
  onSecondaryAction,
  ...restOfProps
}) => {
  return (
    <ModalWithoutIntl id={id} isOpen usePortal onClose={onClose} {...restOfProps}>
      {title && <div className={classNames(css.title, titleClassName)}>{title}</div>}
      {messages && (
        <div className={css.messages}>
          {messages.map((message, i) => (
            <p key={`${id}.message${i}`}>{message}</p>
          ))}
        </div>
      )}
      {confirmError && <p className={css.error}>{confirmError}</p>}
      <div className={css.buttons}>
        {showSecondaryActionButton && (
          <InlineTextButton
            type="button"
            onClick={() => {
              onSecondaryAction();
              onClose();
            }}
            className={css.button}
          >
            {secondaryActionText}
          </InlineTextButton>
        )}
        {showCloseButton && (
          <InlineTextButton type="button" onClick={onClose} className={css.button}>
            {cancelText}
          </InlineTextButton>
        )}
        <PrimaryButton
          type="button"
          onClick={onConfirm}
          inProgress={confirmInProgress}
          disabled={confirmInProgress}
          className={css.primaryBtn}
        >
          {okText}
        </PrimaryButton>
      </div>
    </ModalWithoutIntl>
  );
};

const confirm = async config => {
  const div = document.createElement('div');
  const portalRoot = document.getElementById('portal-root');
  portalRoot.appendChild(div);

  const { onConfirm, onClose, isAsyncConfirm, ...rest } = config;

  const cleanup = () => {
    ReactDOM.unmountComponentAtNode(div);
    portalRoot.removeChild(div);
  };

  return new Promise(resolve => {
    ReactDOM.render(
      <ConfirmModal
        onClose={e => {
          onClose?.(e);
          cleanup();
          resolve(false);
        }}
        onConfirm={() => {
          if (isAsyncConfirm)
            return onConfirm().then(() => {
              cleanup();
              resolve(true);
            });

          onConfirm?.();
          cleanup();
          resolve(true);
        }}
        {...rest}
      />,
      div
    );
  });
};

export default confirm;
